/// <reference types="vite/client" />
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be defined in .env");
}

export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "");

// Edge function helper — always uses anon key to avoid JWT verification issues
// Our edge functions use service_role_key internally, they don't need user JWT
export async function invokeFunction(name: string, body: Record<string, unknown>) {
  const response = await fetch(`${supabaseUrl}/functions/v1/${name}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${supabaseAnonKey}`,
      'apikey': supabaseAnonKey || '',
    },
    // Dev builds (localhost, browser-pane verification, auto-clickers) mark
    // the player they create as test data so no measurement ever counts them.
    // Production builds send false; the flag only ever sets, never clears.
    body: JSON.stringify({ ...body, isTest: import.meta.env.DEV }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Edge Function error (${response.status}): ${text}`);
  }

  return response.json();
}
